var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2,
    height: 12,
    viewBox: "0 0 2 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61408",
    "data-name": "Path 61408",
    d: "M11,7a1,1,0,0,1,2,0v6a1,1,0,0,1-2,0Zm1,9a1,1,0,1,1-1,1A1,1,0,0,1,12,16Z",
    transform: "translate(13 18) rotate(180)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedI);
export default __webpack_public_path__ + "static/media/red-i.391a584c.svg";
export { ForwardRef as ReactComponent };